import React, {useCallback} from 'react';

import BenchlingConfig from 'BenchlingConfig';
import {AgentType} from 'graphql-client/__generated/graphqlGlobalTypes';
import createChatForEntry from 'llm/data-capture/createChatForEntry';
import AsyncButton, {AsyncButtonLoadingBehavior} from 'ui-library/buttons/AsyncButton';
import {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

interface StartChatWithEntryButtonProps {
  entryId: string;
  isEditable: boolean;
}

export default function StartChatWithEntryButton({
  entryId,
  isEditable,
}: StartChatWithEntryButtonProps): JSX.Element {
  const canAsk = BenchlingConfig.LLM_ENABLE_AI_DEEP_RESEARCH;
  const agentType = isEditable || !canAsk ? AgentType.DATA_CAPTURE : AgentType.ASK;
  const handleClick = useCallback(() => createChatForEntry(entryId, agentType), [entryId, agentType]);

  return (
    <AsyncButton
      buttonStyle={ButtonStyle.TERTIARY_BLUE}
      icon="sparkle"
      loadingBehavior={AsyncButtonLoadingBehavior.SPINNER_WITH_TEXT}
      onClick={handleClick}
      size={ButtonSize.MINI}
      text={isEditable ? 'Edit with AI' : 'Ask with AI'}
    />
  );
}
